import { Badge, Flex } from "@chakra-ui/react";

const TIPO_OPERACAO_COLORS: Record<string, string> = {
  NOVO: "#2F80ED",
  REFIN_CARTEIRA: "#9B59B6",
  PORT: "#F5A623",
  SAQUE_RMC: "#3ABB78",
  SAQUE_RCC: "#1B6B5A"
};

export function TipoOperacaoBadge({ tipoOperacao }: { tipoOperacao?: string }) {
  if (!tipoOperacao) return null;
  const values = tipoOperacao
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  return (
    <Flex gap="4px" flexWrap="wrap">
      {values.map((v) => {
        const color = TIPO_OPERACAO_COLORS[v] ?? "#718096";
        return (
          <Badge
            key={v}
            px="8px"
            py="2px"
            borderRadius="10px"
            fontSize="11px"
            fontWeight="700"
            bg="transparent"
            border="1.5px solid"
            borderColor={color}
            color={color}
          >
            {v}
          </Badge>
        );
      })}
    </Flex>
  );
}
